<template>
  <button
    class="flex gap-1 items-center justify-center text-sm px-2 py-2 h-max font-medium text-[#00B087] border-[1px] border-[#00B087] bg-white rounded-[10px] whitespace-nowrap"
    @click="assignOrderAdminModal = true"
  >
    Assign order admin
  </button>
  <Transition name="fade">
    <Dialog
      v-if="assignOrderAdminModal"
      title="Assign Order Admin"
      :show-cancel-button="true"
      :show-save-button="true"
      :show-footer="true"
      :show-close-button="true"
      save-button-text="Assign Admin"
      @closeEvent="closeEvent"
      @saveEvent="assignOrderAdmins"
      @cancelEvent="closeEvent"
      :sm="true"
    >
      <template #modal-content>
        <p class="mb-2">Select Administrator:</p>
        <Select
          append-to-body
          v-model="selectedOrderAdmin"
          placeholder="Select Order Administrator"
          label="name"
          track-by="id"
          :options="orderAdmins"
        />
        <div class="mt-4">
          <p class="mb-2">Select Orders to assign:</p>
          <Select
            multiple
            append-to-body
            v-model="selectedOrders"
            :options="unassignedOrders"
            placeholder="Select Updated Order Status"
            track-by="id"
            label="label"
          >
            <template #option="{ label }">
              <p style="margin: 0">
                {{ label.length > 50 ? label.slice(0, 50) + '...' : label }}
              </p>
            </template>
          </Select>
        </div>
      </template>
    </Dialog>
  </Transition>
</template>
<script setup lang="ts">
import Dialog from '@/components/Shared/Dialog.vue';
import Select from '@/components/Shared/Select.vue';
import { Order, OrderAdminUser } from '@/models';
import { useMainStore } from '@/store';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
const emits = defineEmits(['onSave']);
const store = useMainStore();
const assignOrderAdminModal = ref<boolean>(false);
const { unassignedOrders, orderAdmins } = storeToRefs(store);
const selectedOrderAdmin = ref<OrderAdminUser | null>(null);
const selectedOrders = ref<Order[] | null>(null);
const closeEvent = () => {
  assignOrderAdminModal.value = false;
};
const assignOrderAdmins = async () => {
  if (selectedOrders.value && selectedOrderAdmin.value) {
    const payload = {
      user_id: selectedOrderAdmin.value.id,
      order_ids: selectedOrders.value.map((item) => item.id),
    };
    await store.updateOrderAdmin(payload);
    emits('onSave');
    assignOrderAdminModal.value = false;
  }
};
</script>
<style lang="sass" scoped></style>
